import styled from "styled-components";
import { FC } from "react";

import Text from "@/components/Text";

const Badge = styled(Text)`
  background: ${({ theme }) => theme.colors.warning};
  border-radius: 4px;
  width: 25px;
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SecondaryBadge = styled(Badge)`
  background: ${({ theme }) => theme.colors.research};
`;

interface Props {
  testSequence: 1 | 2;
}

const ProjectsSequenceBadge: FC<Props> = ({ testSequence }) => {
  return (
    <>
      {testSequence === 1 && (
        <Badge $type="smallHeadline" $color="white">
          C1
        </Badge>
      )}
      {testSequence === 2 && (
        <SecondaryBadge $type="smallHeadline" $color="white">
          C2
        </SecondaryBadge>
      )}
    </>
  );
};

export default ProjectsSequenceBadge;
